<div class="row row-content">
	<div class="col d-flex justify-content-center">
		<div class="rounded-1 border form">
			<slot />
		</div>
	</div>
</div>
